module.exports = __webpack_public_path__ + "static/media/fastify.fb59f648.svg";